import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  fetchMobileApp,
  fetchMobileTotal,
  fetchScanDetail,
  fetchMobileRemidiatedFalseTrue,
  mobileSource,
  addMobileApp
} from "../../actions/fakeMobileApp";
import { fetchCustomerDomains } from "../../actions/customer";
import {
  takeDown,
  bulkTakeDown
} from "../../actions/look-alike";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { toastr } from "react-redux-toastr";
import { rescanSingle } from "../../actions/users";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Columnchart from "../common/barchart";
import Pagination from "../Pagination/Pagination";
import ReactApexChart from 'react-apexcharts';
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import $, { data } from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import TicketDetailsModal from "../common/TicketDetailsModal";
import ImageModal from "../common/ImageModal";
import moment from "moment";
import "../../assets/css/recommendation-modal.css";

const MobileApp = () => {
  const [filterData, setfilterData] = useState("all");
  const [type, settype] = useState("");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [value, setvalue] = useState("totals");
  const [totalItems, setTotalItems] = useState(0);
  const [fillActive, setFillActive] = useState("tab1");
  const [activeTab, setActiveTab] = useState("tab1");
  const [isModalThree, setModalThree] = useState(false);
  const [category, setCategory] = useState("all");
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const anchorRef = useRef(null);
  const [search, setSearch] = useState("");
  const [isTakeDownModal, setTakeDownModal] = useState("");
  const [isBulkTakeDownModal, setBulkTakeDownModal] = useState(false);
  const [bulkTakeDownComment, setBulkTakeDownComment] = useState("");
  const [stolenLocation, setStolenLocation] = useState("");
  const [contenSource, setContentSource] = useState("");
  const [infringingIp, setInfringingIp] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [rowId, setRowId] = useState("");
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [detailsActiveTab, setDetailsActiveTab] = useState('info');
  const [subject, setSubject] = useState("");
  const [limit, setLimit] = useState(10);
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [startDate, setStartDate] = useState('');
  const [userComment, setUserComment] = useState("");
  const [endDate, setEndDate] = useState('');
  const [appName, setAppName] = useState("");
  const [appStoreResource, setAppStoreResource] = useState("google");
  const [appUrl, setAppUrl] = useState("");
  const [domain, setDomain] = useState("");
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.bs?.e;
  });

  let totalData = useSelector(
    (state) => state?.fakeMobileApp?.mobileData?.data
  );
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const auth = useSelector((state) => state?.auth?.user);
  const source = useSelector((state) => state?.fakeMobileApp?.source);
  const customerDomains = useSelector(
    (state) => state?.customer?.customerDomains?.data || []
  );
  const dispatch = useDispatch();

  // Add these state variables to handle the date objects
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);



  useEffect(() => {
    fetchMobileTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchScanDetail(id, dispatch);
  }, [id, dispatch]);

  // Manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  // Add useEffect to fetch customer domains
  useEffect(() => {
    // Fetch domains for the current client/organization
    if (id) {
      dispatch(fetchCustomerDomains(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    fetchMobileApp(id, dispatch, page, type, category, startDate, endDate, limit, search, domain);
  }, [id, dispatch, page, type, category, startDate, endDate, limit, search, domain]);

  useEffect(() => {
    setTotalItems(totalData?.totalApps);
  }, [totalData?.totalApps]);

  useEffect(() => {
    mobileSource(id, dispatch)
  }, [id])

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const state = useSelector(
    (state) => state?.fakeMobileApp?.mobileData?.data?.data
  );
  const totalCount = useSelector(
    (state) => state?.fakeMobileApp.totalCount?.data
  );
  const filteredState = state?.filter((item) => !item.isBlacklist);
  const scanCompleted = useSelector(
    (state) => state?.fakeMobileApp?.scanCompleted
  );

  const android = state?.filter(
    (val) => val.source == "Android" || val.appStoreResource == "Android"
  );
  const iOS = state?.filter(
    (val) => (val.source || val.appStoreResource || "")?.toLowerCase() == "ios"
  );
  const thirdParty = state?.filter(
    (val) =>
      val.source == "Third Party Store" ||
      val.appStoreResource == "Third Party Store"
  );

  const scanDetails = useSelector(
    (state) => state?.fakeMobileApp?.totalExcel?.data
  );


  const android_percent = ((android?.length || 0) / (state?.length || 0)) * 100;
  const ios_percent = ((iOS?.length || 0) / (state?.length || 0)) * 100;
  const third_party_percent =
    ((thirdParty?.length || 0) / (state?.length || 0)) * 100;
  const downloadCsvData = state?.map((res) => ({
    StoreName: res?.source || res?.appStoreResource,
    ApplicationName: res?.app_name,
    ApplicationUrl: res?.url,
  }));

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(`${API_URL}/get-appsv2/${id}/excel`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Rogue Mobile Application Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };


  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  // Submit bulk takedown request
  const submitBulkTakeDown = async () => {
    if (bulkTakeDownComment.trim() === "") {
      toastr.error("Error", "Comment cannot be empty.");
      return false;
    }

    if (selectedIds.length === 0) {
      toastr.error("Error", "Please select at least one record.");
      return false;
    }

    try {
      // Build entries array from selected IDs
      const entries = selectedIds.map((recordId) => ({
        recordId: recordId,
        moduleName: "rogue_mobile_applications",
        userComment: bulkTakeDownComment,
      }));

      setBulkTakeDownModal(false);
      
      // Call bulk takedown API
      const response = await bulkTakeDown(id, entries, dispatch);
      
      // Refresh the listing after successful bulk takedown request
      if (response && !response.error) {
        fetchMobileApp(id, dispatch, 1, type, category, startDate, endDate, PageSize, appStoreResource, domain);
        setSelectedIds([]);
        setMultiCheckTrue(false);
      }
      
      // Reset form
      setBulkTakeDownComment("");
    } catch (error) {
      console.error("Error submitting bulk takedown request:", error);
    }
  };

  const snooze = (_id, event) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (event == "markAsRemidiated") {
      let ids = [];
      ids.push(_id);
      const data = {
        action: "markAsRemidiated",
        lookalikeAppIds: selectedIds == 0 ? ids : selectedIds,
        actionNote: "",
        for: "forever",
      };
      fetchMobileRemidiatedFalseTrue(id, dispatch, data, 1, type, category, domain);
      setSelectedValue("pleaseSelect");
      setActionNote("");
      setSelectedIds([]);
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      lookalikeAppIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchMobileRemidiatedFalseTrue(id, dispatch, data, 1, type, category, domain);
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      lookalikeAppIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchMobileRemidiatedFalseTrue(id, dispatch, data, 1, type, category, domain);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  let androidApps = [],
    iosApps = [],
    thirdPartyApps = [];
  let ipArray = [];
  for (let details = 0; details < scanDetails?.scanDetails?.length; details++) {
    ipArray.push(scanDetails?.scanDetails[details]?.length);
    // console.log removed
    let androidApp = scanDetails.scanDetails[details]?.filter(
      (val) =>
        val.source == "google" ||
        val.appStoreResource == "google" ||
        val.source == "Android"
    );
    let iosApp = scanDetails.scanDetails[details]?.filter(
      (val) =>
        (val.source || val.appStoreResource || "")?.toLowerCase() == "ios"
    );
    let thirdPartyApp = scanDetails.scanDetails[details]?.filter(
      (val) =>
        val.source == "thirdparty" ||
        val.appStoreResource == "thirdparty" ||
        val.source == "Third Party Store"
    );

    androidApps.push(androidApp?.length || 0);
    iosApps.push(iosApp?.length || 0);
    thirdPartyApps.push(thirdPartyApp?.length || 0);
  }


  let mapData = filteredState;

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    // setFirstLoad(false)
    // const firstPageIndex = (pageba - 1) * PageSize;
    // const lastPageIndex = firstPageIndex + PageSize;
    currentTableData = mapData;
  }

  const storeName = (val) => {
    if (val == "iOS") return "iOS";
    else if (val == "Android" || val == "google") return "Android";
    else return "Third Party";
  };

  const submitTakeDownValue = async () => {
    if (userComment == "") {
      toastr.error("Error", "Comment cannot be empty.");
      return false;
    }

    try {
      setTakeDownModal(false);
      
      // Create FormData for file upload
      const formData = new FormData();
      formData.append('organisationId', id);
      formData.append('recordId', rowId);
      formData.append('userComment', userComment);
      formData.append('moduleName', 'rogue_mobile_applications');
      
      // Add file if uploaded
      if (uploadedFile) {
        formData.append('file', uploadedFile);
      }

      // Call takeDown API with FormData
      const response = await takeDown(formData, dispatch);
      
      // Refresh the listing after successful takedown request
      if (response && !response.error) {
        fetchMobileApp(id, dispatch, page, type, category, startDate, endDate, limit, search, domain);
      }
      
      // Reset the form fields
      setUserComment("");
      setUploadedFile(null);
      setFilePreview(null);
      // Clear file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error("Error submitting takedown request:", error);
    }
  };

  // Handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        toastr.error("Error", "File size must be less than 10MB");
        e.target.value = null;
        return;
      }
      
      setUploadedFile(file);
      
      // Create preview for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFilePreview(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        setFilePreview(null);
      }
    }
  };

  const handleEditorChange = (even, editor) => {
    const data = editor.getData();
    setEditorContent(data); // Update the state with the new content
  };

  const takeDownValue = (res) => {
    let ip;
    res?.dnsDetails?.map((row) => {
      return Object.keys(row || {}).map((key) => {
        let record = row[key];
        if (record && record.length == 0) return false;
        if (key !== "dns_a") return false;
        record?.map((val) => {
          ip = val;
        });
      });
    });
    let originalWebsite = client.website;
    let domainName = res.url;
    setStolenLocation(originalWebsite);
    setContentSource(domainName);
    setInfringingIp(ip);
    setRowId(res._id);
    setUserComment("");
    setUploadedFile(null);
    setFilePreview(null);
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setTakeDownModal(true);
  };

  const reScan = () => {
    let data = {
      "moduleName": ["rogueMobile"]
    }
    rescanSingle(id, data)
  }

  const getScoreColor = (score) => {
    if (score === null || score === undefined || score == "") return "success"; // Gray for "N/A"
    if (score >= 7) return "danger"; // Red for high risk
    if (score >= 4) return "warning"; // Yellow for medium risk
    return "success"; // Green for low risk
  };


  const transformData = (data) => {
    // Return empty state if data is undefined or null
    if (!data) {
      return {
        series: [],
        labels: []
      };
    }

    // Check if data is an array and has items
    if (!Array.isArray(data) || data.length === 0) {
      return {
        series: [],
        labels: []
      };
    }

    const sortedData = data
      .map(obj => {
        // Additional check to ensure obj is valid
        if (!obj || typeof obj !== 'object') return null;

        const entries = Object.entries(obj);
        if (!entries.length) return null;

        const [label, value] = entries[0];
        return { label, value };
      })
      .filter(item => item !== null) // Remove any null items
      .sort((a, b) => b.value - a.value);

    return {
      series: sortedData.map(item => item.value),
      labels: sortedData.map(item => item.label)
    };
  };

  // Usage with safe check
  const transformedData = transformData(totalCount?.totals) || { series: [], labels: [] };

  const options = {
    chart: {
      type: 'pie',
    },
    labels: transformedData.labels,
    colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'],
    legend: {
      position: 'bottom'
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 300
        },
        legend: {
          position: 'bottom'
        }
      }
    }],
    tooltip: {
      y: {
        formatter: (value) => `${value} user`
      }
    }
  };

  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  const handleAddMobileApp = () => {
    if (!appName) {
      toastr.error("Error", "App name and URL are required.");
      return false;
    }
    if (!appStoreResource) {
      toastr.error("Error", "App store resource is required.");
      return false;
    }
    if (!appUrl) {
      toastr.error("Error", "App URL is required.");
      return false;
    }
    const payload = {
      organisationId: id,
      appName: appName,
      appStoreResource: appStoreResource,
      appUrl: appUrl
    };
    
    addMobileApp(payload, dispatch);
    
    // Reset form and close modal
    setAppName("");
    setAppUrl("");
    setAppStoreResource("google");
    setModalThree(false);
  };

  const [isUrlWarningModal, setIsUrlWarningModal] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [isTicketDetailsModal, setIsTicketDetailsModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");

  const handleUrlClick = (e, url) => {
    e.preventDefault();
    setSelectedUrl(url);
    setIsUrlWarningModal(true);
  };

  const handleUrlConfirm = () => {
    window.open(selectedUrl, '_blank');
    setIsUrlWarningModal(false);
  };

  // Function to handle viewing ticket details
  const handleViewTicketDetails = (app) => {
    setSelectedTicket(app);
    setIsTicketDetailsModal(true);
  };

  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Rogue Mobile Applications</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{ color: "white" }}
                  >
                    Mobile App
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
              <span>
                {auth?.accessLevel == "Admin" && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      reScan();
                    }}
                    style={{ color: "black", fontWeight: "bold" }}
                    className="btn btn-primary mr-1"
                  >
                    Rescan
                  </a>
                )}
              </span>
              <span>
							<a
								onClick={(e) => {
									e.preventDefault();
									setIsRecommendationModal(true);
								}}
								href="#"
								className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
							>
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
								Recommendation
							</a>
						</span>
            <span>
                {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile();
                    }}
                    href="/add-report"
                    className="btn btn-sm btn-primary mr-1 download-report"
                  >
                    Download Details
                  </a>
                )}
              </span>
              
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        {/* <div className="row clearfix">
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-indigo text-white rounded-circle">
                    <i className="fa fa-briefcase"></i>
                  </div>
                  <div className="ml-4">
                    <span>Total Profiles</span>
                    <h4 className="mb-0 font-weight-medium">12</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-azura text-white rounded-circle">
                    <i className="fa fa-credit-card"></i>
                  </div>
                  <div className="ml-4">
                    <span>Detected as Issues</span>
                    <h4 className="mb-0 font-weight-medium">12</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-orange text-white rounded-circle">
                    <i className="fa fa-users"></i>
                  </div>
                  <div className="ml-4">
                    <span>Change in last 30 days</span>
                    <h4 className="mb-0 font-weight-medium">$25,805</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <div className="body">
                <div className="d-flex align-items-center">
                  <div className="icon-in-bg bg-pink text-white rounded-circle">
                    <i className="fa fa-life-ring"></i>
                  </div>
                  <div className="ml-4">
                    <span>Change in last 90 days</span>
                    <h4 className="mb-0 font-weight-medium">$13,651</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row clearfix">
          <div className="col-lg-5 col-md-12">
            <div className="card RecordFoundCard">
              <div className="body" style={{ minHeight: "400px" }}>
                <div className="row justify-content-center">
                  <div className="col-9">
                    {transformedData.series.length > 0 && (
                      <ReactApexChart
                        options={options}
                        series={transformedData.series}
                        type="pie"
                        height={400}
                      />
                    )}
                  </div>
                  {/* <div className="col-4 pb-4 pt-4">
                    <label className="mb-0">Mi Store</label>
                    <h4 className="font-30 font-weight-bold text-col-blue">
                      {totalCount?.Mi Store || 0}
                    </h4>
                  </div>
                  <div className="col-4 pb-4 pt-4">
                    <label className="mb-0">Third Party</label>
                    <h4 className="font-30 font-weight-bold text-col-blue">
                      {totalCount?.totalThirdPartyApps || 0}
                    </h4>
                  </div> */}
                </div>

                {/* <div className="form-group">
                  <label className="d-block">
                    Android Apps{" "}
                    <span className="float-right">
                      {(totalCount?.totalAndroidApps || 0)?.toFixed(0)}%
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-success"
                      role="progressbar"
                      aria-valuenow={totalCount?.totalAndroidApps?.toFixed(0)}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{
                        width: totalCount?.totalAndroidApps?.toFixed(0) + "%",
                      }}
                    ></div>
                  </div>
                </div>

                <div className="form-group">
                  <label className="d-block">
                    iOS Apps{" "}
                    <span className="float-right">
                      {(totalCount?.totaliOSApps || 0)?.toFixed(0)}%
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-success"
                      role="progressbar"
                      aria-valuenow={totalCount?.totaliOSApps?.toFixed(0)}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{
                        width: totalCount?.totaliOSApps?.toFixed(0) + "%",
                      }}
                    ></div>
                  </div>
                </div>

                <div className="form-group">
                  <label className="d-block">
                    Third Party Apps{" "}
                    <span className="float-right">
                      {(totalCount?.totalThirdPartyApps || 0)?.toFixed(0)}%
                    </span>
                  </label>
                  <div className="progress progress-xxs">
                    <div
                      className="progress-bar progress-bar-success"
                      role="progressbar"
                      aria-valuenow={totalCount?.totalThirdPartyApps?.toFixed(
                        0
                      )}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{
                        width:
                          totalCount?.totalThirdPartyApps?.toFixed(0) + "%",
                      }}
                    ></div>
                  </div>
                </div> */}
                {client?.subscriptionType == "trial" && (
                  <div className="card border-warning">
                    <TrialComponent />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12">
            <div className="card user_statistics">
              <div
                className="body"
                id="graphBody"
                style={{ minHeight: "400px" }}
              >
                <h6 className="welcome-textSmall">Previous scan details</h6>
                {scanDetails && (
                  <Columnchart
                    dates={scanDetails?.dates}
                    data={scanDetails?.scanDetails}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
          <li className="nav-item">
            <a
              className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("all");
                settype("");
                setPage(1);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              Current
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("risk-accepted");
                settype("");
                setPage(1);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              Risk Accepted
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("false-positive");
                settype("");
                setPage(1);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              False Positive
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("remidiated");
                settype("");
                setPage(1);
                setSelectedIds([]);
                setSearch("");
                setDomain("");
              }}
            >
              Remediated
            </a>
          </li>
        </ul>
        <div className="card card_tableBox">
          <div className="body">
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="row mb-2 clearfix">
                  <div className="col-sm-3 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      onChange={(e) => { settype(e.target.value); setPage(1) }}
                      value={type}
                    >
                      <option value="">All</option>
                      {source?.data?.map((r) => {
                        return <option value={r}>{r}</option>
                      })}
                    </select>
                  </div>
                  <div className="col-sm-3 mb-2">
                   <div className="searchBoxInput p-0">
                   <input
                      type="search"
                      className="form-control form-control-sm"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                      }}
                    />
                    </div>
                  </div>
                  <div className="col-sm-3 mb-2">
                    <div className="date-picker-container">
                      <div className="date-range-input">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Select date range"
                          value={formatDateRange()}
                          onClick={() => setDatePickerOpen(true)}
                          readOnly
                        />
                        <span className="calendar-icon">
                          <i className="fa fa-calendar" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3 mb-2">
                    <select
                      className="custom-select custom-select-sm form-control form-control-sm"
                      placeholder="Select Domain"
                      value={domain}
                      onChange={(e) => {
                        setDomain(e.target.value);
                        setPage(1);
                      }}
                    >
                      <option value="">All Domains</option>
                      {customerDomains?.domains?.map((domainItem, index) => (
                        <option key={index} value={domainItem}>
                          {domainItem}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-6 mb-2 d-flex align-items-center">
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <Box sx={{ width: 160 }}>
                        <FormControl fullWidth>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedValue}
                            onChange={(event) => {
                              setAction(event.target.value);
                              snooze("", event.target.value);
                            }}
                          >
                            <MenuItem value="pleaseSelect">
                              Snooze Options
                            </MenuItem>
                            <MenuItem
                              value="riskAccepted"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              Risk Accepted
                            </MenuItem>
                            <MenuItem
                              value="markAsFalsePositive"
                              onClick={() => {
                                addModal();
                              }}
                            >
                              False Positive
                            </MenuItem>
                            <MenuItem value="markAsRemidiated">
                              Remediated
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    )}
                    {selectedIds.length > 1 && userPermission &&
                      (category == "false-positive" ||
                        category == "risk-accepted") && (
                        <button
                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                          onClick={() => Unsnoozed("")}
                        >
                          Unsnooze
                        </button>
                      )}
                    {selectedIds.length > 1 && userPermission && category === "all" && (
                      <button
                        className="btn btn-danger btn-sm ml-2"
                        onClick={() => setBulkTakeDownModal(true)}
                        title="Request takedown for selected applications"
                      >
                        <i className="fa fa-arrow-down mr-1"></i>
                        Bulk Takedown Request
                      </button>
                    )}
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                        <th>Store Name</th>
                        <th style={{ width: "80" }}>Application Name</th>
                        <th style={{ width: "80" }}>Application Url</th>
                        <th style={{ width: "80" }}>Rogue App Score</th>
                        <th style={{ width: "80" }}>Details</th>
                        <th style={{ width: "80" }}>Take Down Status</th>
                        {category !== "all" && <th>Action Note</th>}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th style={{ width: "80" }}>Action</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {client?.subscriptionType == "trial" ? (
                        <tr>
                          <td colSpan={8}>
                            <NoData />
                          </td>
                        </tr>
                      ) : (
                        currentTableData?.map(
                          (res, index) =>
                            !res.isBlacklist && (
                              <tr key={index}>
                                {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                  category === "risk-accepted" ||
                                  category === "false-positive") && (
                                    <td>
                                      <input
                                        onClick={() => singleClick(res?._id)}
                                        checked={selectedIds?.includes(res?._id)}
                                        type="checkbox"
                                        className="checkUncheck"
                                      />
                                    </td>
                                  )}
                                {/* <td>
                                  <span>{(page - 1) * 10 + 1 + index}</span>
                                </td> */}
                                <td>
                                  {/* {storeName( */}
                                  {res?.source || res?.appStoreResource || "N/A"}
                                  {/* )} */}
                                </td>
                                <td style={{ whiteSpace: "unset" }}>
                                  {res?.app_name || "N/A"}
                                </td>
                                <td style={{ whiteSpace: "unset" }}>
                                  <a
                                    href={`${res?.url}`}
                                    onClick={(e) => handleUrlClick(e, res?.url)}
                                    style={{ color: "white" }}
                                  >
                                    {res?.url}
                                  </a>
                                </td>
                                <td style={{ whiteSpace: "unset", textAlign: 'center' }}>
                                  <span className={`badge badge-${getScoreColor(res?.rogue_app_score)}`}>
                                    {res?.rogue_app_score || "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm"
                                    onClick={() => {
                                      setSelectedRowDetails(res);
                                      setDetailsModal(true);
                                      setDetailsActiveTab('info');
                                    }}
                                    style={{
                                      backgroundColor: "#17a2b8",
                                      borderColor: "#17a2b8",
                                      color: "#fff",
                                      borderRadius: "4px",
                                      padding: "4px 12px",
                                      transition: "all 0.3s ease",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "6px"
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor = "#138496";
                                      e.target.style.borderColor = "#117a8b";
                                      e.target.style.transform = "translateY(-1px)";
                                      e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor = "#17a2b8";
                                      e.target.style.borderColor = "#17a2b8";
                                      e.target.style.transform = "translateY(0)";
                                      e.target.style.boxShadow = "none";
                                    }}
                                  >
                                    <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                                    <span className="details-slider-action-btn-text">Details</span>
                                  </button>
                                </td>
                                <td>
                                  {res?.ticketExists ? (
                                    <div>
                                      <span className={`badge badge-${res?.ticketStatus === 'completed' ? 'success' : res?.ticketStatus === 'inProgress' ? 'warning' : 'info'}`}>
                                        {res?.ticketStatus === 'completed' ? 'Completed' : 
                                         res?.ticketStatus === 'inProgress' ? 'In Progress' : 
                                         res?.ticketStatus || 'Submitted'}
                                      </span>
                                      <div className="mt-1">
                                        <button
                                          className="btn btn-sm btn-outline-info"
                                          onClick={() => handleViewTicketDetails(res)}
                                          title="View Ticket Details"
                                        >
                                          <i className="fa fa-ticket mr-1"></i>
                                          Ticket Details
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <Link
                                      to="#"
                                      className="takeDownBtn"
                                      onClick={() => takeDownValue(res)}
                                    >
                                      Request Takedown <i className="fa fa-arrow-down ml-2"></i>
                                    </Link>
                                  )}
                                </td>
                                {category !== "all" && <td style={{ whiteSpace: "unset" }}>{res?.actionNote ? res.actionNote : "N/A"}</td>}
                                {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                  <td>
                                    <Box sx={{ width: 160 }}>
                                      <FormControl fullWidth>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={selectedValue}
                                          onChange={(event) => {
                                            setAction(event.target.value);
                                            snooze(
                                              res?._id,
                                              event.target.value
                                            );
                                          }}
                                        >
                                          <MenuItem value="pleaseSelect">
                                            Snooze Options
                                          </MenuItem>
                                          <MenuItem
                                            value="riskAccepted"
                                            onClick={() => {
                                              addModal();
                                              setLookalikeAppId([res._id]);
                                            }}
                                          >
                                            Risk Accepted
                                          </MenuItem>
                                          <MenuItem
                                            value="markAsFalsePositive"
                                            onClick={() => {
                                              addModal();
                                              setLookalikeAppId([res._id]);
                                            }}
                                          >
                                            False Positive
                                          </MenuItem>
                                          <MenuItem value="markAsRemidiated">
                                            Remediated
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Box>
                                  </td>
                                )}
                                {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                                  category === "false-positive") && (
                                    <td>
                                      <button
                                        className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                        onClick={() => Unsnoozed(res?._id)}
                                      >
                                        Unsnooze
                                      </button>
                                    </td>
                                  )}
                              </tr>
                            )
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={limit}
                        onPageChange={(page) => setPage(page)}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value);
                        setPage(1);
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
        className={`modal fade Form-Wizard-modal ${isTakeDownModal ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Submit Take Down Request
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setTakeDownModal(false);
                  setUserComment("");
                  setUploadedFile(null);
                  setFilePreview(null);
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card card_ck">
                    <div className="body">
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12"><strong>Comment</strong> <span className="text-danger">*</span></label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setUserComment(e.target.value)}
                            value={userComment}
                            className="form-control"
                            rows="4"
                            placeholder="Please provide details about the takedown request..."
                            required
                          ></textarea>
                        </div>
                      </div>
                      
                      <div className="col-md-12 mt-3">
                        <label className="col-lg-12 col-md-12"><strong>Upload Supporting File/Screenshot</strong> (Optional)</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <input
                            ref={fileInputRef}
                            type="file"
                            className="form-control"
                            accept="image/*,.pdf,.doc,.docx"
                            onChange={handleFileChange}
                          />
                          <small className="form-text text-muted">
                            Supported formats: Images, PDF, DOC, DOCX (Max 10MB)
                          </small>
                        </div>
                      </div>

                      {filePreview && (
                        <div className="col-md-12 mt-2">
                          <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                              <span>File Preview</span>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  setUploadedFile(null);
                                  setFilePreview(null);
                                  // Clear file input
                                  if (fileInputRef.current) {
                                    fileInputRef.current.value = '';
                                  }
                                }}
                              >
                                <i className="fa fa-times"></i> Remove
                              </button>
                            </div>
                            <div className="card-body text-center">
                              <img
                                src={filePreview}
                                alt="Preview"
                                className="image-clickable"
                                style={{ maxWidth: '100%', maxHeight: '300px', objectFit: 'contain' }}
                                onClick={() => {
                                  setImageModalSrc(filePreview);
                                  setImageModalOpen(true);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {uploadedFile && !filePreview && (
                        <div className="col-md-12 mt-2">
                          <div className="alert alert-info d-flex justify-content-between align-items-center">
                            <span>
                              <i className="fa fa-file mr-2"></i>
                              {uploadedFile.name} ({(uploadedFile.size / 1024).toFixed(2)} KB)
                            </span>
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => {
                                setUploadedFile(null);
                                setFilePreview(null);
                                // Clear file input
                                if (fileInputRef.current) {
                                  fileInputRef.current.value = '';
                                }
                              }}
                            >
                              <i className="fa fa-times"></i> Remove
                            </button>
                          </div>
                        </div>
                      )}
                      
                      <div className="col-lg-12 col-md-12">
                        <button
                          className="btn btn-primary btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => submitTakeDownValue()}
                          disabled={!userComment.trim()}
                        >
                          <i className="fa fa-paper-plane mr-2"></i>
                          Submit Request
                        </button>
                        <button
                          className="btn btn-default btn-sm pull-right"
                          style={{ marginTop: "10px", marginRight: "10px" }}
                          onClick={() => {
                            setTakeDownModal(false);
                            setUserComment("");
                            setUploadedFile(null);
                            setFilePreview(null);
                            // Clear file input
                            if (fileInputRef.current) {
                              fileInputRef.current.value = '';
                            }
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bulk Takedown Modal */}
      <div
        className={`modal fade Form-Wizard-modal ${isBulkTakeDownModal ? "d-block show" : ""}`}
      >
        <div className="modal-dialog modal-lg" id="bulkTakedownModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="bulkTakedownModalLabel">
                Bulk Takedown Request 
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setBulkTakeDownModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="card card_ck">
                    <div className="body">
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Comment <span className="text-danger">*</span></label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setBulkTakeDownComment(e.target.value)}
                            value={bulkTakeDownComment}
                            className="form-control"
                            rows="3"
                            placeholder="Enter comment for all selected items..."
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 takeDownButtonBox">
                        <button
                          className="btn btn-default btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => {
                            setBulkTakeDownModal(false);
                            setBulkTakeDownComment("");
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary btn-sm mr-1 pull-right"
                          style={{ marginTop: "10px" }}
                          onClick={() => submitBulkTakeDown()}
                        >
                          Submit Bulk Takedown
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        {datePickerOpen && (
          <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
            <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
              <div className="date-range-picker-header">
                {tempStartDate && tempEndDate
                  ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                  : "Select date range"}
              </div>
              <div className="date-range-calendars">
                <div>
                  <h6>From</h6>
                  <DatePicker
                    selected={tempStartDate}
                    onChange={(date) => {
                      setTempStartDate(date);
                      if (tempEndDate && date > tempEndDate) {
                        setTempEndDate(null);
                      }
                    }}
                    selectsStart
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <h6>To</h6>
                  <DatePicker
                    selected={tempEndDate}
                    onChange={(date) => setTempEndDate(date)}
                    selectsEnd
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    minDate={tempStartDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </div>
              <div className="date-range-actions">
                <button
                  className="date-range-apply"
                  onClick={applyDateRange}
                >
                  Apply Filter
                </button>
                <button
                  className="date-range-cancel"
                  onClick={cancelDateSelection}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      {/* Mobile App Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
          setDetailsActiveTab('info');
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-mobile-alt mr-2"></i>
              Mobile App Details
              {selectedRowDetails?.app_name && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails.app_name}
                </span>
              )}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                type="button"
                className="details-slider-close"
                onClick={() => {
                  setDetailsModal(false);
                  setSelectedRowDetails(null);
                  setDetailsActiveTab('info');
                }}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div className="details-slider-tabs">
            <button
              className={`details-slider-tab ${detailsActiveTab === 'info' ? 'active' : ''}`}
              onClick={() => setDetailsActiveTab('info')}
            >
              <i className="fa fa-info-circle mr-2"></i>
              App Info
            </button>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {detailsActiveTab === 'info' && (
                  <>
                    {/* Basic Information Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-info-circle"></i>
                        Basic Information
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Store Name:</span>
                        <span className="details-info-value">{selectedRowDetails?.source || selectedRowDetails?.appStoreResource || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Application Name:</span>
                        <span className="details-info-value">{selectedRowDetails?.app_name || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Application URL:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.url ? (
                            <a href={selectedRowDetails.url} target="_blank" rel="noopener noreferrer" style={{ color: "#453acd" }}>
                              {selectedRowDetails.url}
                            </a>
                          ) : "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Rogue App Score:</span>
                        <span className="details-info-value">
                          <span className={`badge badge-${getScoreColor(selectedRowDetails?.rogue_app_score)}`}>
                            {selectedRowDetails?.rogue_app_score || "N/A"}
                          </span>
                        </span>
                      </div>
                    </div>

                    {/* Rogue App Analysis Section */}
                    {selectedRowDetails?.rogue_app_analysis && (
                      <div className="details-section">
                        <div className="details-section-title">
                          <i className="fa fa-search"></i>
                          Rogue App Analysis
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Conclusion:</span>
                          <span className="details-info-value">{selectedRowDetails.rogue_app_analysis?.conclusion || "N/A"}</span>
                        </div>
                        {selectedRowDetails.rogue_app_analysis?.evidences_of_suspicion && selectedRowDetails.rogue_app_analysis.evidences_of_suspicion.length > 0 && (
                          <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                            <span className="details-info-label" style={{ marginBottom: "8px" }}>Evidences of Suspicion:</span>
                            <ul style={{ margin: 0, paddingLeft: "20px" }}>
                              {selectedRowDetails.rogue_app_analysis.evidences_of_suspicion.map((evidence, idx) => (
                                <li key={idx} style={{ marginBottom: "4px", color: "#212529" }}>
                                  <i className="fas fa-exclamation-triangle text-warning mr-2"></i>
                                  {evidence}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Scoring Reasons Section */}
                    {selectedRowDetails?.rogue_app_scoring_reasons && Array.isArray(selectedRowDetails.rogue_app_scoring_reasons) && selectedRowDetails.rogue_app_scoring_reasons.length > 0 && (
                      <div className="details-section">
                        <div className="details-section-title">
                          <i className="fa fa-chart-line"></i>
                          Scoring Reasons
                        </div>
                        <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                          <ul style={{ margin: 0, paddingLeft: "20px" }}>
                            {selectedRowDetails.rogue_app_scoring_reasons.map((reason, idx) => (
                              <li key={idx} style={{ marginBottom: "4px", color: "#212529" }}>
                                <i className="fas fa-exclamation-circle text-danger mr-2"></i>
                                {reason}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}

                    {/* App Summary Section */}
                    {selectedRowDetails?.rogue_app_summary && (
                      <div className="details-section">
                        <div className="details-section-title">
                          <i className="fa fa-file-alt"></i>
                          App Summary
                        </div>
                        <div className="details-info-item">
                          <span className="details-info-label">Developer:</span>
                          <span className="details-info-value">{selectedRowDetails.rogue_app_summary?.developer || "N/A"}</span>
                        </div>
                        <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                          <span className="details-info-label" style={{ marginBottom: "8px" }}>Description:</span>
                          <span className="details-info-value">{selectedRowDetails.rogue_app_summary?.description || "N/A"}</span>
                        </div>
                        {selectedRowDetails.rogue_app_summary?.fullpage_screenshot_url && (
                          <div className="details-info-item" style={{ flexDirection: "column", alignItems: "flex-start" }}>
                            <span className="details-info-label" style={{ marginBottom: "8px" }}>App Screenshot:</span>
                            <img 
                              src={selectedRowDetails.rogue_app_summary.fullpage_screenshot_url} 
                              alt="App Screenshot" 
                              className="img-fluid image-clickable"
                              style={{ maxWidth: "100%", borderRadius: "4px", border: "1px solid #dee2e6" }}
                              onClick={() => {
                                setImageModalSrc(selectedRowDetails.rogue_app_summary.fullpage_screenshot_url);
                                setImageModalOpen(true);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
        
        {/* Add Mobile App Modal */}
        <div className={`modal fade Form-Wizard-modal ${isModalThree === 'Form Wizard modalThree' ? "d-block show" : ""}`}>
          <div className="modal-dialog modal-lg" id="addMobileAppModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Mobile App</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setModalThree(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="card mb-0">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>App Name <span className="text-danger">*</span></label>
                          <input 
                            type="text" 
                            className="form-control"
                            value={appName}
                            onChange={(e) => setAppName(e.target.value)}
                            placeholder="Enter app name"
                            required
                          />
                        </div>
                      </div>
                      
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>App Store <span className="text-danger">*</span></label>
                          <select 
                            className="form-control"
                            value={appStoreResource}
                            onChange={(e) => setAppStoreResource(e.target.value)}
                          >
                            <option value="google">Android (Google Play)</option>
                            <option value="ios">iOS (App Store)</option>
                            <option value="Third Party Store">Third Party Store</option>
                          </select>
                        </div>
                      </div>
                      
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>App URL <span className="text-danger">*</span></label>
                          <input 
                            type="text" 
                            className="form-control"
                            value={appUrl}
                            onChange={(e) => setAppUrl(e.target.value)}
                            placeholder="Enter app URL"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div className="row mt-3">
                      <div className="col-md-12 text-right">
                        <button 
                          className="mr-2 btn btn-round btn-default"
                          onClick={() => setModalThree(false)}
                        >
                          Cancel
                        </button>
                        <button 
                          className="btn btn-primary"
                          onClick={handleAddMobileApp}
                        >
                          Add Mobile App
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add URL Warning Modal */}
      <div className={`modal fade Form-Wizard-modal ${isUrlWarningModal ? "d-block show" : ""}`}>
        <div className="modal-dialog" id="urlWarningModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">External Link Warning</h5>
              <button
                type="button"
                className="close"
                onClick={() => setIsUrlWarningModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="alert alert-warning mb-3">
                <i className="fa fa-exclamation-triangle mr-2"></i>
                You are about to leave this site and visit an external URL. This link may lead to a third-party website. Please proceed with caution.
              </div>
              <p className="mb-0">URL: <strong>{selectedUrl}</strong></p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                onClick={() => setIsUrlWarningModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUrlConfirm}
              >
                Proceed Anyway
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Ticket Details Modal */}
      <TicketDetailsModal
        isOpen={isTicketDetailsModal}
        onClose={() => setIsTicketDetailsModal(false)}
        ticketData={selectedTicket}
      />

      <ImageModal
        isOpen={imageModalOpen}
        onClose={() => setImageModalOpen(false)}
        imageSrc={imageModalSrc}
      />

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button
              className="recommendation-modal-close"
              onClick={() => setIsRecommendationModal(false)}
            >
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${
                    activeRecommendationTab === "guide" ? "active" : ""
                  }`}
                  onClick={() => setActiveRecommendationTab("guide")}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${
                    activeRecommendationTab === "checklist" ? "active" : ""
                  }`}
                  onClick={() => setActiveRecommendationTab("checklist")}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek continuously monitors official app stores, third-party marketplaces, and APK distribution
                  platforms to identify rogue mobile applications impersonating the organization's brand.
                  These applications are frequently used to steal credentials, harvest sensitive data,
                  distribute malware, or conduct financial fraud.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Are Rogue Mobile Applications</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Rogue mobile applications are unauthorized apps that misuse the organization's brand name,
                      logo, or services. These apps are not published or endorsed by the organization and are
                      designed to deceive users into installing them.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Detection Coverage</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Official app stores (Google Play, Apple App Store)</li>
                      <li>Third-party app stores and APK repositories</li>
                      <li>Direct download links hosted on external domains</li>
                      <li>Apps using brand keywords, logos, or product names</li>
                      <li>Repackaged or trojanized versions of legitimate apps</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Common Abuse Scenarios</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Credential harvesting via fake login screens</li>
                      <li>Malware and spyware embedded in APK files</li>
                      <li>Payment fraud and fake invoice generation</li>
                      <li>SMS interception and OTP theft</li>
                      <li>Reputation damage due to user complaints or reviews</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Risk Indicators Used by BrandSek</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Application name and package similarity</li>
                      <li>Developer identity and publishing history</li>
                      <li>Permission abuse (SMS, contacts, storage, accessibility)</li>
                      <li>Distribution outside official app stores</li>
                      <li>User reviews, ratings, and reported abuse</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Business, Legal & Compliance Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Rogue mobile apps can directly lead to financial fraud, customer data compromise,
                      and regulatory scrutiny. Proactive identification and takedown supports ISO 27001
                      brand protection controls, mobile security best practices, and consumer protection obligations.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Rogue App Validation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Confirm app is not published by the organization</li>
                      <li>Validate brand name, logo, or service misuse</li>
                      <li>Review app store listing and download source</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.7 · Brand Protection</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Security & Fraud Risk Assessment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Analyze permissions and behavioral indicators</li>
                      <li>Check for credential harvesting or malware traits</li>
                      <li>Correlate with fraud, phishing, or abuse reports</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.16 · Mobile Security</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Takedown & Containment</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Initiate app store or hosting takedown request</li>
                      <li>Notify legal, SOC, and brand teams</li>
                      <li>Publish user advisory if required</li>
                    </ul>
                    <div className="compliance-tag">CERT-In · App Store Abuse Guidelines</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Ongoing Monitoring & Governance</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Monitor for re-uploads or mirror apps</li>
                      <li>Track takedown confirmation and closure</li>
                      <li>Retain evidence for audit and legal reference</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Continuous Monitoring</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ); 
};

export default MobileApp;
